import useFieldHelper from '../fieldHelper';
import TextField from './TextField';
import { FieldProps } from '../types';
// libs
import React from 'react';
// components
// services
// services

const capitalize = (text: string) => text && text[0].toUpperCase() + text.slice(1).toLowerCase();

const CapitalizedField = ({ source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const value = getValue();

  return <TextField value={capitalize(value)} {...props} />;
};

export default CapitalizedField;
